import type { ToolCategory } from './Types';

export const TOOL_CLASSIFICATION_SOURCE_VERSION = '0.0.1-dev.20260817202359';

const FRONTEND_TOOL_NAMES = new Set([
    'aggregate_config_set',
    'aggregate_dimension_metric_remove',
    'aggregate_dimension_update',
    'aggregate_filter_value_candidates_get',
    'aggregate_metric_filter_set',
    'aggregate_metric_update',
    'aggregate_snapshot_get',
    'aggregate_source_add',
    'aggregate_source_filter_set',
    'aggregate_source_remove',
    'aggregate_validation_update',
    'automation_enable',
    'automation_node_create',
    'automation_node_create_configured',
    'automation_node_http_test',
    'automation_node_remove',
    'automation_node_update',
    'automation_snapshot_get',
    'automation_trigger_activity_candidates_get',
    'automation_trigger_other_candidates_get',
    'automation_trigger_update',
    'builder_save',
    'dashboard_component_chart_configure',
    'dashboard_component_configure',
    'dashboard_component_copy',
    'dashboard_component_create',
    'dashboard_component_delete',
    'dashboard_component_fields_configure',
    'dashboard_component_layout_update',
    'dashboard_component_refresh',
    'dashboard_components_create',
    'dashboard_data_source_configure',
    'dashboard_data_source_list',
    'dashboard_data_source_schema_get',
    'dashboard_settings_configure',
    'dashboard_snapshot_get',
    'dashboard_validate',
    'data_page_component_chart_configure',
    'data_page_component_configure',
    'data_page_component_copy',
    'data_page_component_create',
    'data_page_component_delete',
    'data_page_component_fields_configure',
    'data_page_container_configure',
    'data_page_data_source_configure',
    'data_page_data_source_list',
    'data_page_data_source_schema_get',
    'data_page_form_config_get',
    'data_page_layout_configure',
    'data_page_layout_move',
    'data_page_settings_configure',
    'data_page_snapshot_get',
    'data_page_validate',
    'flow_enable',
    'flow_get_attrs',
    'flow_layout_auto',
    'flow_layout_get',
    'flow_line_condition_set',
    'flow_line_get',
    'flow_line_remove',
    'flow_line_upsert',
    'flow_node_create',
    'flow_node_delete',
    'flow_node_get',
    'flow_node_position_update',
    'flow_node_update',
    'flow_schema_snapshot',
    'flow_set_attrs',
    'flow_start_using',
    'flow_theme_change',
    'flow_version_create',
    'flow_version_desc_set',
    'flow_version_switch',
    'flow_versions_get',
    'form_attributes_get',
    'form_attributes_update',
    'form_data_linkage_configure',
    'form_data_linkage_source_schema_get',
    'form_data_linkage_sources_list',
    'form_field_attributes_get',
    'form_field_attributes_update',
    'form_field_create',
    'form_field_move',
    'form_field_select',
    'form_field_update',
    'form_fields_operate',
    'form_location_center_search',
    'form_recycle_list',
    'form_recycle_restore',
    'form_snapshot_get',
    'form_submit_validation_update',
    'user_decision',
    'workbench_close_page',
    'workbench_focus_page',
    'workbench_inspect',
    'workbench_open_page',
    'workbench_reload_page',
]);

const BACKEND_TOOL_NAMES = new Set([
    'aggregate_list',
    'aggregate_manage',
    'app_create',
    'app_entry_move',
    'app_entry_rename',
    'app_form_list',
    'app_group_create',
    'app_group_remove',
    'app_home_get',
    'app_home_update',
    'app_list',
    'app_menu_get',
    'app_remove',
    'app_rename',
    'auth_group_capability_get',
    'auth_group_create',
    'auth_group_enabled_update',
    'auth_group_get',
    'auth_group_list',
    'auth_group_remove',
    'auth_group_update',
    'automation_create',
    'automation_list',
    'automation_node_schema_get',
    'automation_remark_update',
    'begin_final_response',
    'builder_result_present',
    'contact_department_list',
    'contact_member_list',
    'contact_role_list',
    'contact_subject_resolve',
    'dashboard_component_schema_get',
    'dashboard_create',
    'dashboard_list',
    'dashboard_settings_schema_get',
    'data_contact_department_list',
    'data_contact_member_list',
    'data_page_component_schema_get',
    'data_page_create',
    'data_page_enable',
    'data_page_list',
    'filter_capability_get',
    'filter_plan_structure_validate',
    'form_attribute_schema_get',
    'form_create',
    'form_data_list',
    'form_data_title_get',
    'form_data_title_update',
    'form_field_schema_get',
    'form_fields_preview',
    'form_filter_value_candidates_get',
    'form_mock_data_create',
    'form_notification_capability_get',
    'form_notification_create',
    'form_notification_list',
    'form_notification_remove',
    'form_notification_schema_get',
    'form_notification_update',
    'form_view_create',
    'form_view_get',
    'form_view_list',
    'form_view_remove',
    'form_view_schema_get',
    'form_view_scope_update',
    'form_view_update',
    'formula_mock',
    'formula_validate',
    'user_followup',
]);

export function classifyTool(name: string): ToolCategory {
    if (FRONTEND_TOOL_NAMES.has(name)) return 'frontend';
    if (BACKEND_TOOL_NAMES.has(name)) return 'backend';
    return 'other';
}
